module.exports = __webpack_public_path__ + "img/step5.8d767976.png";